export default __webpack_public_path__ + "static/media/g6.29dda56f.webp";